import {
  format,
  today,
  yesterday,
  differenceInDays,
  subWeeks,
  subMonths,
  subQuarters,
  startOfISOWeek,
  startOfMonth,
  startOfQuarter,
  startOfYear,
  endOfISOWeek,
  endOfMonth,
  endOfQuarter,
  isBefore,
} from '../../../utils/date';

export const minGrowthRatePeriod = 28;
export const minGrowthRateSelectable = 60;
export const dayPeriods = [30, 60, 90, 180, 365, 730, 1095, 1460];
export const definedPeriods = ['week', 'month', 'quarter', 'year'];

const getLatestDate = (maxDate) =>
  isBefore(maxDate, yesterday()) ? format(maxDate) : format(yesterday());
const getCountFromDate = (maxDate) =>
  isBefore(maxDate, yesterday()) ? format(maxDate) : format(today());

export const definedPeriodsNames = {
  week: 'Previous Week',
  month: 'Previous Month',
  quarter: 'Previous Quarter',
  year: 'Year to Date',
};

export const dateRangeToSubmit = (period, maxDate) => {
  const countFromDate = getCountFromDate(maxDate);
  const latestDate = getLatestDate(maxDate);

  return {
    week: {
      rangePeriod:
        differenceInDays(
          endOfISOWeek(subWeeks(countFromDate, 1)),
          startOfISOWeek(subWeeks(countFromDate, 1))
        ) + 1,
      from: format(startOfISOWeek(subWeeks(countFromDate, 1))),
      to: format(endOfISOWeek(subWeeks(countFromDate, 1))),
    },
    month: {
      rangePeriod:
        differenceInDays(
          endOfMonth(subMonths(countFromDate, 1)),
          startOfMonth(subMonths(countFromDate, 1))
        ) + 1,
      from: format(startOfMonth(subMonths(countFromDate, 1))),
      to: format(endOfMonth(subMonths(countFromDate, 1))),
    },
    quarter: {
      rangePeriod:
        differenceInDays(
          endOfQuarter(subQuarters(countFromDate, 1)),
          startOfQuarter(subQuarters(countFromDate, 1))
        ) + 1,
      from: format(startOfQuarter(subQuarters(countFromDate, 1))),
      to: format(endOfQuarter(subQuarters(countFromDate, 1))),
    },
    year: {
      rangePeriod: differenceInDays(latestDate, startOfYear(countFromDate)) + 1,
      from: format(startOfYear(countFromDate)),
      to: latestDate,
    },
  }[period];
};

export const rangePeriodFromYesterday = (period, maxDate) => {
  const countFromDate = getCountFromDate(maxDate);
  const latestDate = getLatestDate(maxDate);

  return {
    week: differenceInDays(latestDate, startOfISOWeek(subWeeks(countFromDate, 1))) + 1,
    month: differenceInDays(latestDate, startOfMonth(subMonths(countFromDate, 1))) + 1,
    quarter: differenceInDays(latestDate, startOfQuarter(subQuarters(countFromDate, 1))) + 1,
    year: differenceInDays(latestDate, startOfYear(countFromDate)) + 1,
  }[period];
};

export const getActiveOption = (customFrom, customTo, maxDate) => {
  if (customFrom && customTo) {
    const rangePeriod = differenceInDays(customTo, customFrom) + 1;

    // dayPeriods
    if (customTo === format(getLatestDate(maxDate)) && dayPeriods.includes(rangePeriod)) {
      return {
        value: rangePeriod.toString(),
        label:
          rangePeriod > 365
            ? `Last ${parseInt(rangePeriod / 365, 10)} Years`
            : `Last ${rangePeriod} Days`,
      };
    }

    // definedPeriods
    const previousPeriods = definedPeriods.map((definedPeriod) => ({
      value: definedPeriod,
      ...dateRangeToSubmit(definedPeriod, maxDate),
    }));

    const activePeriod = previousPeriods.find(
      ({ from, to }) => from === customFrom && to === customTo
    );

    if (activePeriod) {
      return {
        value: activePeriod.value,
        label: definedPeriodsNames[activePeriod.value],
      };
    }
  }

  return { value: 'custom', label: 'Custom' };
};
